import React, { useState } from 'react';
import {
  Box,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useBreakpointValue,
  Text,
} from '@chakra-ui/react';

interface ThumbnailPreviewProps {
  imageUrl: string;
}

const ThumbnailPreview: React.FC<ThumbnailPreviewProps> = ({ imageUrl }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const modalSize = useBreakpointValue({ base: 'full', md: 'xl' });
  const hasImage = Boolean(imageUrl?.trim());

  if (!hasImage) {
    return (
      <Box
        width="80px"
        height="48px"
        borderRadius="md"
        bg="gray.50"
        border="1px solid"
        borderColor="gray.200"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text fontSize="xs" color="gray.500">No image</Text>
      </Box>
    );
  }

  return (
    <>
      <Box
        as="button"
        onClick={() => setIsModalOpen(true)}
        cursor="pointer"
        borderRadius="md"
        overflow="hidden"
        boxShadow="sm"
        transition="transform 0.2s"
        _hover={{ transform: 'scale(1.05)' }}
        _focus={{ outline: 'none', boxShadow: 'outline' }}
      >
        <Image src={imageUrl} alt="Thumbnail" width="80px"
  height="48px" objectFit="cover" />
      </Box>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size={modalSize}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          bg="gray.900"
          color="white"
          maxW="90%"
          maxH="90vh"
          height="90vh"
          borderRadius="lg"
          overflow="hidden"
        >
          <ModalCloseButton
            color="white"
            size="lg"
            _hover={{ color: 'gray.300' }}
          />
          <ModalBody
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={0}
            height="100%"
          >
            <Image
              src={imageUrl}
              alt="Full-size preview"
              maxHeight="90vh"
              maxWidth="100%"
              objectFit="contain"
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ThumbnailPreview;
